import * as actionTypes from 'app-redux/actionTypes'
// import { updateObject } from 'app-redux/utility'

export default function maintenanceReducer(state = '', action) {
  switch (action.type) {
    case actionTypes.SET_MAINTENANCE:
      return action.payload
    default:
      return state
  }
}
